import * as React from 'react'
import {FC} from 'react'
import {Form} from 'antd'
import {LOCATION} from '../../constants/fields'
import Select from 'antd/lib/select'
import {useSearchLazy, useSearchQuery} from '../../store/api/fias-api'

const {Item} = Form
const {Option} = Select

interface LocationPropsInterface {
    code: string
    onChange?: (value) => void
}

const Location: FC<LocationPropsInterface> = ({code, onChange}) => {
    const [search, searchState] = useSearchLazy()
    const {data, isFetching, isSuccess} = searchState

    const handleSearch = value => {
        if (value.length >= 3)
            search({
                regionCode: code,
                namePart: value,
            })
    }

    const renderOptions = () => {
        if (!isSuccess) return null

        let options = []
        data.data?.map(element =>
            options.push(
                <Option key={element.guid} value={element.guid}>
                    {element.fullName}
                </Option>
            )
        )
        return options
    }

    return (
        <Item {...LOCATION}>
            <Select
                size='large'
                className='calc-territory'
                optionFilterProp='children'
                placeholder={'Введите населенный пункт...'}
                showSearch={true}
                loading={isFetching}
                onSearch={handleSearch}
                dropdownStyle={{
                    minHeight: '250px',
                }}
                disabled={code.length === 0}
            >
                {renderOptions()}
            </Select>
        </Item>
    )
}

export default Location
